var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"snowWrap"},_vm._l((_vm.currentFlakesCount),function(n){return _c('div',{key:n,staticClass:"snow"})}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }